import * as React from 'react';
const SvgArrowDown = (props) => (
  <svg
    width={13}
    height={8}
    style={{ width: 13, height: 8 }}
    viewBox="0 0 13 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.49251 0.120332C3.97295 -0.415211 4.64812 2.85724 6.64754 3.67746C8.15435 2.56974 10.1654 -1.53703 12.4517 0.613595C14.2453 2.29915 11.1796 5.15444 9.82343 6.25653C6.88515 8.6411 5.89993 8.56218 3.0196 6.12687C1.64319 4.96277 -2.0485 0.881367 1.49251 0.120332Z"
      fill="#5A5A87"
    />
  </svg>
);
export default SvgArrowDown;
